module.exports = __webpack_public_path__ + "static/media/bootstrap.ffded238.svg";